import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { AppProvider } from "./context/AppContext";

const root = ReactDOM.createRoot(document.getElementById('app'));

if (!localStorage.getItem("token")) {
  localStorage.setItem("token", crypto.randomUUID());
}

root.render(
  <AppProvider>
    <App />
  </AppProvider>
);
